"use client";

// Note: Next.js metadata must be in a server component file.
// We can't add it directly to this client component.
// Metadata for this route lives in the sibling metadata/layout files.
//
// This route is a thin shell: it wires Suspense and delegates all browse
// orchestration + rendering to MarketView (which consumes useMarketBrowse).
// See docs buyer-market-discovery-ux § Implementation ownership.

import { Suspense } from "react";
import MarketView from "@/components/market/MarketView";
import MarketViewSkeleton from "@/components/market/MarketViewSkeleton";

export default function BrowsePage() {
  return (
    <Suspense fallback={<MarketViewSkeleton />}>
      <MarketView />
    </Suspense>
  );
}
